import { Box } from "@mui/material";
import { LogoDiv, Logo, Illustration } from "./styled.onboarding";
import { FlexBox } from "common/Reusables";
import React from "react";
import styled from "styled-components";
import logo from "assets/logos/MyEdge PNG.png";
import loginIllustration from "assets/images/AuthIllustrator.svg";

const AuthScreenWrapper = ({ children }) => {
  return (
    <AuthScreenWrapper.Wrapper>
      <Box height="100%" className="left_panel">
        <LogoDiv>
          <Logo src={logo} />
        </LogoDiv>
        <FlexBox sx={{ flexBasis: "60%" }}>{children}</FlexBox>
      </Box>
      <Box bgcolor="#FFE7E7" className="right_panel">
        <FlexBox alignItems="center" jc="center" height="100%">
          <Box width={"90%"}>
            <Illustration
              style={{
                width: "90%",
                marginInline: "auto",
              }}
              src={loginIllustration}
            />
          </Box>
        </FlexBox>
      </Box>
    </AuthScreenWrapper.Wrapper>
  );
};

export default AuthScreenWrapper;

AuthScreenWrapper.Wrapper = styled(Box)`
  height: 100vh;
  width: 100vw;
  display: flex;
  .left_panel {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-inline: 8rem;
    padding-top: 2rem;
    @media (max-width: 1200px) {
      padding-inline: 2rem;
    }
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .right_panel {
    width: 40%;
    height: 100%;
    @media (max-width: 768px) {
      display: none;
    }
  }
`;
